import {Component} from 'react';
import h from 'react-hyperscript';
import {footnote} from 'Components/Typography/Typography';
import {handleButtonKeyEvents} from 'Src/utils/utils';

class FilterItem extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = this.props.inactiveClasses;
    this.activeClasses = `${this.props.inactiveClasses} active`;
    this.state = {
      classes: this.inactiveClasses,
    };
  }

  componentDidMount() {
    this.checkClasses();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filteredProducts !== prevProps.filteredProducts) {
      this.checkClasses();
    }
  }

  checkClasses() {
    const filteredIds = this.props.filteredProducts.map((product) => {
      return product.id;
    });

    const totalIds = this.props.totalFilters.map((product) => {
      return product.id;
    });

    if (totalIds.length === filteredIds.length) {
      this.setClasses(this.inactiveClasses);
    } else {
      this.setClasses(this.inactiveClasses);

      if (filteredIds.includes(this.props.id)) {
        this.setClasses(this.activeClasses);
      }
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  render() {
    const handleFilterClick = this.props.handleFilterClick;

    return (
      h('div', {
        key: `filter-${this.props.index}`,
        id: `filter--${this.props.id}--${this.props.index}`,
        className: this.state.classes,
        datafilter: this.props.id,
        tabIndex: 0,
        onClick: handleFilterClick,
        onKeyUp: (e) => handleButtonKeyEvents(e, handleFilterClick),
      }, [
        h('span', {
          className: 'dot',
          style: {
            backgroundColor: this.props.color,
          },
        }, null),
        h(footnote, null, this.props.title),
      ])
    );
  }
}

export default FilterItem;
